import type { UIMessage } from "ai";
import { ListTree } from "lucide-react";
import { errorMessage, isToolPart, TOOL_LABELS, toolNameOf, type ToolPartLike, unwrapOutput } from "../lib/tool-parts";

/** Per-answer trace: which tools the agent used, in order, with which parameters and outcome. */
export function Trace({ message }: { message: UIMessage }) {
  const steps = message.parts.filter((p) => isToolPart(p)) as unknown as ToolPartLike[];
  if (!steps.length) return null;
  return (
    <details className="text-[11px] text-roast/70">
      <summary className="flex cursor-pointer list-none items-center gap-1 select-none hover:text-espresso">
        <ListTree className="size-3" /> Traza · {steps.length} {steps.length === 1 ? "herramienta" : "herramientas"}
      </summary>
      <ol className="mt-1 space-y-1 rounded-lg bg-crema p-2">
        {steps.map((s, i) => {
          const name = toolNameOf(s);
          const { isError, data } = unwrapOutput(s.output);
          const status =
            s.state === "output-available" ? (isError ? "error" : "ok") : s.state === "output-error" ? "error" : s.state.replace("approval-", "aprobación ").replace("output-denied", "rechazado");
          return (
            <li key={s.toolCallId ?? i} className="break-all">
              <span className="font-medium">
                {i + 1}. {TOOL_LABELS[name] ?? name}
              </span>{" "}
              <code className="font-mono text-[10px]">{name}({JSON.stringify(s.input ?? {})})</code>{" "}
              <span className={status === "error" ? "text-red-700" : "text-emerald-700"}>· {status}</span>
              {status === "error" && <span className="block text-red-700/80">{errorMessage(data)}</span>}
            </li>
          );
        })}
      </ol>
    </details>
  );
}
